/**
 * React Query hook for opportunities listing
 */ import { useQuery } from '@tanstack/react-query';
import { opportunityApiConnect } from '../../../lib/api/opportunityApi.connect';
/**
 * Hook to fetch opportunities with pagination and optional search
 */ export function useOpportunities(params = {}, enabled = true) {
    return useQuery({
        queryKey: [
            'opportunities',
            params
        ],
        queryFn: ()=>opportunityApiConnect.listOpportunities(params),
        staleTime: 60000,
        enabled
    });
}
